import React from 'react';
import TemplateProyect from '../TemplateProyect';

function Tusalud() {
    const infoTect = ["React", "HTML", "CSS", "JavaScript", "Bootstrap", "Sass", "", "", "", ""];
    const infoProyect = [
        "Tu Salud",
        "https://www.youtube.com/embed/sgPz3e4j440",
        "Page dedicated and focused on nutritional and physical health",
        "https://brandongrimaldom.github.io/tusalud/",
        "/web-development"
    ];

    return (
        <React.Fragment>
            <TemplateProyect
                title={infoProyect[0]}
                video={infoProyect[1]}
                description={infoProyect[2]}
                github={infoProyect[3]}
                tecfilter={infoTect}
                after={infoProyect[4]}  >
            </TemplateProyect>
        </React.Fragment>
    );
}
export default Tusalud;